export enum SetupQuestion {
    INFO = 1,
    GENDER = 2,
    SMOKER_STATUS = 3,
    DATEOFBIRTH = 5,
    TITLE = 6,
    FIRST_NAME = 7,
    MIDDLE_NAME = 8,
    LAST_NAME = 9,
    EMAIL = 11,
    PHONE = 12,
    CONTACT_TIME = 13
}
